<template>
  <div>
    <v-col cols="12" class="pt-4 pb-3">
      <v-row>
        <v-col
          cols="12" sm="6" md="4" lg="3"
          xl="3"
        >
          <h4 class="font-weight-bold text-body-2 text-uppercase mb-3 text-neutral900">
            rubra
          </h4>
          <ol class="text-body-2 pl-0">
            <li v-for="link in about" :key="link.to" class="mb-2">
              <a
                :href="link.to" target="_blank" rel="noopener noreferrer"
                class="text-neutral400 text-decoration-none"
              >
                {{ t(link.text) }}
              </a>
            </li>
          </ol>
        </v-col>

        <v-col
          cols="12" sm="6" md="4" lg="3"
          xl="3"
        >
          <h4 class="font-weight-bold text-body-2 text-uppercase mb-3 text-neutral900">
            {{ t('layout.footer.legal') }}
          </h4>
          <ol class="text-body-2 pl-0">
            <li
              v-for="link in legal"
              :key="link.to"
              class="text-neutral400 cursor-pointer mb-2"
            >
              <router-link v-slot="{ navigate }" :to="link.to" custom>
                <a class="text-neutral400 text-decoration-none" @click="navigate">
                  {{ t(link.text) }}
                </a>
              </router-link>
            </li>
          </ol>
        </v-col>
      </v-row>
    </v-col>
    
    <!-- Divider positioned at the bottom, above the copyright -->
    <div>
      <v-divider color="neutral50" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

// Use the global t function from the i18n instance
const { t } = useI18n()

const about = computed(() => [
  { to: `${CONFIG.landingpageUrl}${t('layout.nav.about.link')}`, text: 'layout.nav.about' },
  { to: `${CONFIG.landingpageUrl}${t('layout.nav.get_help.link')}`, text: 'layout.nav.get_help' },
  { to: `${CONFIG.landingpageUrl}${t('layout.nav.feedback.link')}`, text: 'layout.nav.feedback' },
])

const legal = computed(() => [
  { to: '/legal/imprint', text: 'layout.nav.imprint' },
  { to: '/legal/tos', text: 'layout.nav.tos' },
  { to: '/legal/privacy', text: 'layout.nav.pp' },
  { to: '/legal/licenses', text: 'layout.nav.licenses' },
])
</script>

<style lang="scss" scoped>
ol {
  list-style: none;
}

a {
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>
